import React, { useCallback, useState } from 'react';

import Lottie from 'lottie-react';
import { useNavigate } from 'react-router-dom';

import { ArtifactsRevealTransition } from '@pkg/components';
import animationData from '@pkg/lotties/artifact-entry-point.json';

import './ArtifactsEntryPoint.scss';

const ANIMATION_DURATION = 650;

export const ArtifactsEntryPoint = () => {
    const navigate = useNavigate();
    const [visibleAnimator, setVisibleAnimator] = useState(false);
    const rendererSettings = {
        preserveAspectRatio: 'xMidYMid meet',
    };

    const handleNavigate = useCallback(() => {
        setVisibleAnimator(true);
        setTimeout(() => navigate('/artifacts'), ANIMATION_DURATION);
    }, [navigate]);

    return (
        <>
            {visibleAnimator && <ArtifactsRevealTransition duration={ANIMATION_DURATION} />}
            <span className="yat-sidebar-artifacts-entry-point" onClick={handleNavigate}>
                <div className="yat-sidebar-artifacts-entry-point__mask">
                    {!!animationData && (
                        <Lottie
                            animationData={animationData}
                            autoplay={true}
                            loop={true}
                            rendererSettings={rendererSettings}
                        />
                    )}
                </div>
            </span>
        </>
    );
};
